import styled from 'styled-components'
import { A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/autoplay'

import Responsive from '../assets/config/Responsive'
import Colors from '../assets/styles/Colors'
import DoubleVerticalLines from '../assets/v2/JSX/DoubleVerticalLines'

import aldagi from '../assets/img/company-logos/aldagi-logo.svg'
import ardi from '../assets/img/company-logos/Ardi-Logo.png'
import gpi from '../assets/img/company-logos/gpi.png'
import imedil from '../assets/img/company-logos/imedil.png'
import irao from '../assets/img/company-logos/irao.png'
import psp from '../assets/img/company-logos/psp.svg'

// Types
interface CompanyLogo {
  logo: string
  link: string
}

// Constants
const COMPANY_LOGOS: CompanyLogo[] = [
  {
    logo: aldagi,
    link: 'https://aldagi.ge/ka/',
  },
  {
    logo: ardi,
    link: 'https://www.ardi.ge/ge',
  },
  {
    logo: gpi,
    link: 'https://www.gpih.ge/ka',
  },
  {
    logo: imedil,
    link: 'https://imedil.ge/home/ge',
  },
  {
    logo: irao,
    link: 'https://www.irao.ge/',
  },
  {
    logo: psp,
    link: 'https://wizer.ge/index.php',
  },
]

const SWIPER_BREAKPOINTS = {
  100: {
    slidesPerView: 4,
  },
  640: {
    slidesPerView: 5,
  },
  768: {
    slidesPerView: 5,
  },
  1024: {
    slidesPerView: 7,
  },
} as const

const SWIPER_CONFIG = {
  spaceBetween: 50,
  loop: true,
  loopAdditionalSlides: 10,
  speed: 3000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
} as const

const LOGO_DUPLICATION_FACTOR = 3

// Component
const AutoplayCarousel = () => {
  // Duplicate logos for seamless infinite loop, especially needed for large screens
  const duplicatedLogos = new Array(LOGO_DUPLICATION_FACTOR).fill(COMPANY_LOGOS).flat()

  return (
    <Wrapper>
      <DecoreStyle />
      <Swiper breakpoints={SWIPER_BREAKPOINTS} modules={[Autoplay, A11y]} {...SWIPER_CONFIG}>
        {duplicatedLogos.map((item, index) => (
          <SwiperSlide key={`logo-${index}`}>
            <LogoLink href={item.link} target="_blank" rel="noopener noreferrer">
              <LogoImage src={item.logo} alt={`Company logo ${index + 1}`} />
            </LogoLink>
          </SwiperSlide>
        ))}
      </Swiper>
    </Wrapper>
  )
}

// Styled Components
const LogoLink = styled.a`
  text-decoration: none;
  height: fit-content;
`

const LogoImage = styled.img`
  height: 60px;
  width: 100%;
  object-fit: contain;
`

const DecoreStyle = styled(DoubleVerticalLines)`
  position: absolute;
  top: 0;
  left: 80px;

  ${Responsive.tablet} {
    display: none;
  }

  ${Responsive.mobile} {
    display: none;
  }
`

const Wrapper = styled.div`
  position: relative;
  user-select: none;
  height: 380px;
  width: 100%;
  background-color: ${Colors.white};
  display: grid;
  place-items: center;
  overflow: hidden;

  .swiper {
    width: 100%;
  }

  .swiper-pointer-events {
    height: fit-content;
  }

  .swiper-wrapper {
    transition-timing-function: linear;
  }

  .swiper-slide {
    overflow: hidden;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;

    &:hover {
      filter: unset !important;
    }
  }

  ${Responsive.tablet} {
    height: 150px;
  }

  ${Responsive.mobile} {
    height: 150px;
  }
`

export default AutoplayCarousel
